import type { ReactNode } from "react";
import { ThemeProvider as NextThemesProvider } from "next-themes";

export function ThemeProvider({ children }: { children: ReactNode }): JSX.Element {
  return (
    <NextThemesProvider attribute="class" defaultTheme="system" enableSystem storageKey="he-dashboard-theme">
      {children}
    </NextThemesProvider>
  );
}
